import apis from "../../core/apis.js";

class TransactionResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options, name, id) {
    return this.$resource(apis[name] + id + "/transactions").get(options);
  }

  get(id) {
    return this.$resource(apis.transaction + id).get();
  }

  search(search = "") {
    return this.$resource(apis.transaction).get({ search });
  }

  post(item) {
    return this.$resource(apis.transaction).save(item);
  }

  update(id, item) {
    return this.$resource(apis.transaction + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  refund(item) {
    return this.$resource(apis.transactions + "refund_card").save(item);
  }
}

export default TransactionResource;



// WEBPACK FOOTER //
// ./src/resources/transaction/transaction.resource.js